import { render, staticRenderFns } from "./cookie-bar-component.vue?vue&type=template&id=6b4b090a&scoped=true"
import script from "./cookie-bar-component.ts?vue&type=script&lang=ts&external"
export * from "./cookie-bar-component.ts?vue&type=script&lang=ts&external"
import style0 from "./cookie-bar-component.scss?vue&type=style&index=0&id=6b4b090a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4b090a",
  null
  
)

export default component.exports